import { ITailwindCssPluginConfig } from '../../shared/types/ITailwindCssPlugin';

export function typographyPlugin (config: ITailwindCssPluginConfig): void {
    const { addUtilities }: ITailwindCssPluginConfig = config;

    addUtilities({
        '.caret-primary': {
            caretColor: '#00CAF2',
        },
        '.caret-error': {
            caretColor: '#CD2026',
        },
        '.type-h1': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.4px',
            fontSize: '6rem',
        },
        '.type-h2': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.4px',
            fontSize: '4.5rem',
        },
        '.type-h3': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.4px',
            fontSize: '3rem',
        },
        '.type-h4': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.4px',
            fontSize: '2rem',
        },
        '.type-h5': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.18px',
            fontSize: '1.5rem',
        },
        '.type-h6': {
            fontFamily: 'Clan, Roboto, sans-serif',
            letterSpacing: '0.32px',
            fontSize: '1.125rem',
        },
        '.type-subtitle1': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.53px',
            fontSize: '1rem',
            fontWeight: 'bold',
        },
        '.type-subtitle2': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.53px',
            fontSize: '0.875rem',
            fontWeight: 'bold',
        },
        '.type-body1': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.32px',
            fontSize: '1.125rem',
        },
        '.type-body2': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.32px',
            fontSize: '1rem',
        },
        '.type-button': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.53px',
            fontSize: '1.25rem',
            fontWeight: 'bold',
        },
        '.type-overline': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.53px',
            fontSize: '1.25rem',
            fontWeight: 'bold',
        },
        '.type-caption': {
            fontFamily: 'National, Roboto, sans-serif',
            letterSpacing: '0.4px',
            fontSize: '0.875rem',
            fontStyle: 'italic',
        },
    });
}
